import { Styles } from '@readcloud/clouds-and-content/src/components/styles/styles';

import { SUBDOMAINS } from './enums';

const domainsToStyle = {
  [SUBDOMAINS.MAIN]: Styles.Default,
  [SUBDOMAINS.LOCALHOST]: Styles.Default,
  [SUBDOMAINS.WINC]: Styles.Winc,
  [SUBDOMAINS.ROSEBANKSC]: Styles.Rosebank,
  [SUBDOMAINS.JIS]: Styles.Jis,
  [SUBDOMAINS.HILLCRESTCC]: Styles.Hillcrest,
  [SUBDOMAINS.STLAURENCE]: Styles.Stlaurence,
  [SUBDOMAINS.S_CROSS]: Styles.SCross,
  [SUBDOMAINS.BEAUDESERT]: Styles.Beaudesert,
  [SUBDOMAINS.ROCKHAMPTON]: Styles.Rockhampton,
  [SUBDOMAINS.PGONLINE]: Styles.PGOnline,
  [SUBDOMAINS.PRSPNE]: Styles.PRSPNE,
  [SUBDOMAINS.ISFWATERLOO]: Styles.ISFWaterloo,
  [SUBDOMAINS.BSSSC]: Styles.Bsssc,
  [SUBDOMAINS.ALBANYSHS]: Styles.Albanyshs,
  [SUBDOMAINS.AVIATIONHIGH]: Styles.Aviationhigh,
  [SUBDOMAINS.AVILACOLLEGE]: Styles.Avilacollege,
  [SUBDOMAINS.BILOELASHS]: Styles.Biloelashs,
  [SUBDOMAINS.BUNDABERGSHS]: Styles.Bundabergshs,
  [SUBDOMAINS.GYMPIESHS]: Styles.Gympieshs,
  [SUBDOMAINS.MALANDASHS]: Styles.Malandashs,
  [SUBDOMAINS.MOSSMANSHS]: Styles.Mossmanshs,
  [SUBDOMAINS.NAMBOURSC]: Styles.Namboursc,
  [SUBDOMAINS.NANANGOSHS]: Styles.Nanangoshs,
  [SUBDOMAINS.PEDARECC]: Styles.Pedarecc,
  [SUBDOMAINS.PROSERPINESHS]: Styles.Proserpineshs,
  [SUBDOMAINS.REDBANKPLAINSSHS]: Styles.Redbankplains,
  [SUBDOMAINS.SPRINGFIELDCENTRALSHS]: Styles.SpringfieldCentral,
  [SUBDOMAINS.STJAMESCOLLEGE]: Styles.StJamesCollege,
  [SUBDOMAINS.SPCC]: Styles.Spcc,
  [SUBDOMAINS.TANNUMSANDSSHS]: Styles.Tannumsands,
  [SUBDOMAINS.TCCR]: Styles.Tccr,
  [SUBDOMAINS.VPSHS]: Styles.Vpshs,
  [SUBDOMAINS.WSSC]: Styles.Wssc,
  [SUBDOMAINS.WMYC]: Styles.Wmyc,
  [SUBDOMAINS.WOODCRESTSC]: Styles.Woodscrestsc,
  [SUBDOMAINS.YERONGASHS]: Styles.Yerongashs,
  [SUBDOMAINS.SUNCOASTCC]: Styles.Suncoastcc,
  [SUBDOMAINS.CHANCELLORSC]: Styles.Chancellorsc,
  [SUBDOMAINS.INDOOROOSHS]: Styles.Indoorooshs,
  [SUBDOMAINS.STMARYSCOLLEGE]: Styles.Stmaryscollege,
  [SUBDOMAINS.SAMPOERNAACADEMY]: Styles.Sampoernaacademy,
  [SUBDOMAINS.ASPLEYSHS]: Styles.Aspleyshs,
  [SUBDOMAINS.WARWICKSHSWA]: Styles.Warwickshswa,
  [SUBDOMAINS.WYNNUMSHS]: Styles.Wynnumshs,
  [SUBDOMAINS.TRINITYBAYSHS]: Styles.Trinitybayshs,
  [SUBDOMAINS.SISSCHOOLS]: Styles.Sisschools,
  [SUBDOMAINS.CHARTERHOUSEALMATY]: Styles.CharterHouse,
  [SUBDOMAINS.EMMAUS]: Styles.Emmaus,
  [SUBDOMAINS.CALLIOPE]: Styles.Calliopeshs,
  [SUBDOMAINS.ATHERTON]: Styles.Athertonshs,
  [SUBDOMAINS.PRONIN]: Styles.Pronin,
  [SUBDOMAINS.TRANSYLVANIA]: Styles.Transylvania,
  [SUBDOMAINS.VICTORYCOLLEGE]: Styles.VictoryCollege,
  [SUBDOMAINS.BMEZY]: Styles.Bmezy,
  [SUBDOMAINS.PERIDIS]: Styles.Peridis,
  [SUBDOMAINS.CALVARY]: Styles.Calvary,
  [SUBDOMAINS.SCOTSPGC]: Styles.Scotspgc,
  [SUBDOMAINS.IBID]: Styles.Ibid,
  [SUBDOMAINS.SEVENSTEPS]: Styles.SevenSteps,
  [SUBDOMAINS.DALBY]: Styles.Dalby,
} as const;

export { domainsToStyle };
